import * as React from "react";
import { ListLine } from "../framework/listLine";
import { IRecordListItemUserQualification, RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";

export interface IUserQualificationListStateColProp {
    item: IRecordListItemUserQualification;
}

export class UserQualificationListStateCol extends React.Component<IUserQualificationListStateColProp, {}> {
    render() {
        const item = this.props.item;
        return (
            <div className="flex WithIcons jend">
                <span className={"stateText userQualification state" + (item.userFurtherEducations.length ? (item.valid ? "2" : "1") : "0")}>
                    {RecordListItemUserQualification.getQualificationState(item)}
                </span>
            </div>
        );
    }
}

//UserQualificationListLine
export interface IUserQualificationListLineProp {
    item: IRecordListItemUserQualification;
    selected: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
}

export class UserQualificationListLine extends React.Component<IUserQualificationListLineProp, {}> {
    handleClick = () => {
        const props = this.props;
        if (!props.item.furtherEducationId || !props.item.userFurtherEducations.length) return;
        props.onClick(props.item.userFurtherEducations[0].id);
    };

    handleLongPress = () => {
        const props = this.props;
        if (!props.item.furtherEducationId || !props.item.userFurtherEducations.length) return;
        props.onLongPress(props.item.userFurtherEducations[0].id);
    };

    render() {
        const props = this.props;
        const item = props.item;
        return (
            <ListLine
                id={item.id}
                selected={props.selected}
                classes={"line" + (props.selected ? " selected" : "")}
                onClick={this.handleClick}
                onLongPress={this.handleLongPress}
                onRefreshList={props.onRefreshList}>
                <div className="row">
                    <div className="col col-8 bold ">{item.code}</div>
                    <div className="col col-4 flex jend"><UserQualificationListStateCol item={item} /></div>
                </div>
            </ListLine>
        );
    }
}